module.exports = {
  success: 'Сохранить',
  cancel: 'Отменить',
  remove: 'Удалить',
  warning: 'Предупреждение',
  confirm: 'Применить',
  fillFromTemplate: 'Заполнить из шаблона',
  save_as_template: 'Сохранить как шаблон',
};
